import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";
import { getNativeLanguageCodes } from "../../../utils/getNativeLanguageCodes";

export default function CssfPdfLanguageSkillsSection( { resumeData } ) {
    const { languageSkills } = extractResumeDataDocumentSection( resumeData );
    const documentLanguage = 'fr'; // Forced for CSSF

    const nativeLanguageCodes = getNativeLanguageCodes( languageSkills );

    const styles = StyleSheet.create( {
        section: {
            flexDirection: 'row',
            marginBottom: 10,
            fontSize: 10,
        },
        textStart: {
            textAlign: 'start',
            fontFamily: 'Verdana, sans-serif',
            fontSize: '9pt',
            color: "#009999",
            margin: 0,
            marginTop: 4,
        },
        leftColumn: {
            width: '16%',
        },
        rightColumn: {
            width: '80%',
            marginLeft: 12,
        },
        lineTitle: {
            height: 1,
            backgroundColor: "#979797",
            marginRight: 20,
            marginBottom: 10,
        },
        table: {
            width: '100%',
        },
        tableHeader: {
            width: '20%',
            textAlign: "center",
            marginTop: '2px',
            fontSize: '7pt',
            fontFamily: "Verdana, sans-serif",
            color: "#009999"
        },
        row2: {
            width: '25%',
        },
        row3: {
            width: '25%',
        },
    } );

    return (
        <>
            <View style={ [ styles.section, { marginBottom: 0 } ] }>
                <View style={ [ styles.leftColumn, {
                    width: "30%",
                    justifyContent: "flex-end",
                    alignItems: "flex-end"
                } ] }>
                    <Text style={ [ styles.textStart, {
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        display: "flex"
                    } ] }>
                        LANGUES
                    </Text>
                </View>
                <View style={ [ styles.rightColumn, {
                    width: "70%",
                    justifyContent: "flex-end",
                    alignItems: "flex-end"
                } ] }>
                    <View style={ {
                        width: "100%",
                        height: 5,
                        backgroundColor: "#009999",
                        marginVertical: 4
                    } }/>
                </View>
            </View>
            <View style={ [ styles.section, { marginBottom: 10 } ] }>
                <View style={ [ styles.leftColumn, {
                    width: "30%",
                    justifyContent: "flex-end",
                    alignItems: "flex-end"
                } ] }>
                    <Text style={ [ styles.textStart, {
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        display: "flex"
                    } ] }>
                        Langue(s) maternelle(s)
                    </Text>
                </View>
                <View style={ [
                    styles.rightColumn,
                    {
                        width: "70%",
                        justifyContent: "flex-end",
                        alignItems: "flex-start"
                    }
                ] }>
                    <Text style={ {
                        ...styles.textStart,
                        color: "#3F3A38",
                    } }>
                        { languageSkills
                            .filter( skill => skill.language )
                            .filter( skill => nativeLanguageCodes.includes( skill.language.code ) )
                            .sort( ( a, b ) => a.order - b.order )
                            .map( ( skill ) => skill.language.translations[ documentLanguage ] )
                            .join( ', ' ) }
                    </Text>
                </View>
            </View>
            <View style={ [ styles.section, { marginBottom: 0, marginTop: 10 } ] }>
                <View style={ [ styles.leftColumn, {
                    width: "30%",
                    justifyContent: "flex-start",
                    alignItems: "flex-end"
                } ] }>
                    <Text style={ styles.textStart }>
                        Autre(s) langue(s)
                    </Text>
                    <View style={ { minHeight: "43px" } }></View>
                    { languageSkills
                        .filter( skill => skill.language )
                        .filter( skill => !nativeLanguageCodes.includes( skill.language.code ) )
                        .sort( ( a, b ) => a.order - b.order )
                        .map( ( skill, index ) => (
                            <Text key={ index }
                                  style={ {
                                      ...styles.textStart,
                                      textAlign: "right",
                                      marginBottom: 14
                                  } }>
                                { skill.language.translations[ documentLanguage ] }
                            </Text>
                        ) ) }
                </View>
                <View style={ [
                    styles.rightColumn,
                    {
                        width: "70%",
                        justifyContent: "flex-start",
                        alignItems: "flex-start"
                    }
                ] }>
                    <View style={ styles.table }>
                        <View style={ { ...styles.section, color: "#3F3A38" } }>
                            <Text style={ {
                                ...styles.tableHeader,
                                width: '40%',
                                textTransform: "uppercase",
                            } }>
                                COMPRENDRE
                            </Text>
                            <Text
                                style={ {
                                    ...styles.tableHeader,
                                    width: '40%',
                                    textTransform: "uppercase",
                                } }>
                                PARLER
                            </Text>
                            <Text style={ {
                                ...styles.tableHeader,
                                width: '20%',
                                textTransform: "uppercase",
                            } }>
                                ÉCRIRE
                            </Text>
                        </View>
                        <View style={ styles.lineTitle }/>

                        <View style={ { ...styles.section, color: "#3F3A38" } }>
                            <Text style={ styles.tableHeader }>
                                Écouter
                            </Text>
                            <Text style={ styles.tableHeader }>
                                Lire
                            </Text>
                            <Text style={ styles.tableHeader }>
                                Prendre part à une{ "\n" }conversation
                            </Text>
                            <Text style={ styles.tableHeader }>
                                S'exprimer oralement en continu
                            </Text>
                            <Text style={ styles.tableHeader }>
                                { ' ' }
                            </Text>
                        </View>
                        <View style={ styles.lineTitle }/>
                        { languageSkills
                            .filter( skill => skill.language )
                            .filter( skill => !nativeLanguageCodes.includes( skill.language.code ) )
                            .sort( ( a, b ) => a.order - b.order )
                            .map( ( skill, index ) => (
                                <React.Fragment key={ index }>
                                    { index > 0 && <View style={ styles.lineTitle }/> }
                                    <View style={ styles.section }>
                                        <Text style={ {
                                            ...styles.row2,
                                            fontSize: 9,
                                            fontFamily: "Verdana, sans-serif",
                                            color: "#3F3A38",
                                            textAlign: "center"
                                        } }>
                                            { skill.listeningComprehensionLevel?.translations?.[ documentLanguage ] }
                                        </Text>
                                        <Text style={ {
                                            ...styles.row2,
                                            fontSize: 9,
                                            fontFamily: "Verdana, sans-serif",
                                            color: "#3F3A38",
                                            textAlign: "center"
                                        } }>
                                            { skill.readingComprehensionLevel?.translations?.[ documentLanguage ] }
                                        </Text>
                                        <Text style={ {
                                            ...styles.row3,
                                            fontSize: 9,
                                            fontFamily: "Verdana, sans-serif",
                                            color: "#3F3A38",
                                            textAlign: "center"
                                        } }>
                                            { skill.oralInteractionLevel?.translations?.[ documentLanguage ] }
                                        </Text>
                                        <Text style={ {
                                            ...styles.row3,
                                            fontSize: 9,
                                            fontFamily: "Verdana, sans-serif",
                                            color: "#3F3A38",
                                            textAlign: "center"
                                        } }>
                                            { skill.continuousOralExpressionLevel?.translations?.[ documentLanguage ] }
                                        </Text>
                                        <Text style={ {
                                            ...styles.row3,
                                            fontSize: 9,
                                            fontFamily: "Verdana, sans-serif",
                                            color: "#3F3A38",
                                            textAlign: "center"
                                        } }>
                                            { skill.writingExpressionLevel?.translations?.[ documentLanguage ] }
                                        </Text>
                                    </View>
                                </React.Fragment>
                            ) ) }
                    </View>
                </View>
            </View>
        </>
    );
}
